var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0079 2.60167e-05C17.1125 1.50164e-05 18.0079 0.895487 18.0079 2.00009L18.0077 7.3814C18.0077 7.93369 17.56 8.38139 17.0077 8.38137C16.4554 8.38135 16.0077 7.93363 16.0077 7.38134L16.0079 3.64356L9.11656 10.5348C8.72603 10.9254 8.09287 10.9254 7.70234 10.5348C7.31182 10.1443 7.31182 9.51116 7.70234 9.12063L14.8229 2.00004L10.9997 2.00008C10.4474 2.00008 9.99971 1.55237 9.99971 1.00009C9.9997 0.447802 10.4474 8.19034e-05 10.9997 7.634e-05L16.0079 2.60167e-05ZM2.55556 1.90442C1.87778 1.90442 1.22776 2.17366 0.748505 2.65292C0.269245 3.13218 0 3.7822 0 4.45997V15.3489C0 16.0266 0.269246 16.6767 0.748505 17.1559C1.22776 17.6352 1.87778 17.9044 2.55556 17.9044H13.4444C14.1222 17.9044 14.7722 17.6352 15.2515 17.1559C15.7308 16.6767 16 16.0266 16 15.3489V11.9044C16 11.3521 15.5523 10.9044 15 10.9044C14.4477 10.9044 14 11.3521 14 11.9044V15.3489C14 15.4962 13.9415 15.6375 13.8373 15.7417C13.7331 15.8459 13.5918 15.9044 13.4444 15.9044H2.55556C2.40821 15.9044 2.26691 15.8459 2.16272 15.7417C2.05853 15.6375 2 15.4962 2 15.3489V4.45997C2 4.31263 2.05853 4.17132 2.16272 4.06714C2.26691 3.96295 2.40821 3.90442 2.55556 3.90442H6C6.55228 3.90442 7 3.4567 7 2.90442C7 2.35213 6.55228 1.90442 6 1.90442H2.55556Z",
    fill: "#AFAFAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/externalLink.db95f0cb7d5b9d4008d1fafac6dac761.svg";
export { ForwardRef as ReactComponent };